export default {
  nl: {
    errorMessages: {
      alreadyCompleted: 'Afspraak is al voltooid.',
      canceled: 'De afspraaklink is verlopen. Neem contact op met uw dienstverlener om een nieuwe afspraak in te plannen.',
      caseNotFound: 'Afspraak helaas niet gevonden.',
      signatureNotFound: 'De link is verlopen',
      signatureNotFoundParagraph: 'De monteur kan een nieuwe QR code genereren zodat je via de link de werkbon kan ondertekenen.',
      closed: 'Afspraak helaas niet gevonden.',
      appointmentNotPossible: 'Het maken van een afspraak is helaas nog niet mogelijk.',
      noAppointmentYet: 'Het maken van een afspraak is helaas nog niet mogelijk.',
      noStylesheet: 'Geen layout gevonden.',
      maintenance: 'Under construction',
      default: 'Er is iets fout gegaan.'
    },
  },
  en: {
    errorMessages: {
      alreadyCompleted: 'The appointment has already been completed.',
      canceled: 'The appointment link has expired. Please contact your service provider to schedule a new appointment.',
      caseNotFound: 'No ticket found.',
      signatureNotFound: 'Link is expired',
      signatureNotFoundParagraph: 'The technician can generate a new QR code so you can sign the work order via the link.',
      closed: 'Your appointment has not been found.',
      appointmentNotPossible: 'Unfortunately you can\'t make an appointment yet.',
      noAppointmentYet: 'You can\'t make an appointment yet',
      noStylesheet: 'No layout found.',
      maintenance: 'Under construction',
      default: 'Something went wrong.'
    },
  }
};
